import { REVIEW_STATS, REVIEW_RATING_TEXT } from "@/data/reviewStats";
const stats = [
  { n: "Family Owned", label: "in Livonia" },
  { n: "1", label: "NWFA Certified Wood Flooring Inspector in MI" },
  { n: `${REVIEW_RATING_TEXT} ★`, label: `${REVIEW_STATS.count} Google Reviews` },
  { n: "6+", label: "Premium Brands" },
  { n: "1", label: "National Award" },
];

const StatsBar = () => (
  <div className="bg-gradient-to-r from-gold-700 to-primary py-8 md:py-12 px-5 md:px-12">
    <div className="max-w-[1100px] mx-auto grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-0">
      {stats.map((stat, i) => (
        <div
          key={stat.label}
          className={`text-center px-2 md:px-4 text-primary-foreground ${i < stats.length - 1 ? "lg:border-r lg:border-primary-foreground/[.18]" : ""}`}
        >
          <span className="font-display text-[clamp(28px,5vw,60px)] font-semibold leading-none block mb-1 md:mb-2">{stat.n}</span>
          <span className="text-[9px] md:text-[10px] font-semibold tracking-[.12em] md:tracking-[.16em] uppercase opacity-70 leading-snug">{stat.label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default StatsBar;
